import { useGetRefundRequest } from "@/api/refund/get-refund-request";
import FullscreenLoading from "@/components/layout/fullscreen-loading";
import PageWrapper from "@/components/layout/page-wrapper";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatDate } from "@/lib/utils";
import { Footprints } from "lucide-react";
import { useParams } from "react-router";

const RequestDetails = () => {
    const { request_id } = useParams();
    const { data: request, isLoading, isError } = useGetRefundRequest({ id: request_id as string });

    if (isLoading) {
        return <FullscreenLoading />;
    }

    if (isError) {
        return (
            <PageWrapper pageTitle="Refund & Replacement Requests" currentPage="Refund & Replacement Requests">
                <div className="flex items-center justify-center h-screen">
                    <Card className="p-4 shadow-none">
                        <h3 className="text-lg font-bold">Error</h3>
                        <Separator className="my-4" />
                        <p>Something went wrong while fetching the request details.</p>
                    </Card>
                </div>
            </PageWrapper>
        );
    }

    console.log(request);

    return (
        <PageWrapper
            pageTitle={`Request ID #${request_id}`}
            currentPage={`Request ID #${request_id}`}
            previousPages={[{ title: "Refund & Replacement Requests", url: "/app/refund-request" }]}
        >
            <div>
                <div className="flex items-end justify-between">
                    <div>
                        <p className="font-bold text-gray-700">Order ID: {request?.data?.order_id || "N/A"}</p>
                        <p className="text-gray-600">{formatDate(new Date(request?.data?.created_at))}</p>
                    </div>
                    {/* <Button>Accept Request</Button> */}
                </div>
                <Card className="mt-4 p-4 shadow-none">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>Product</TableHead>
                                <TableHead>Qty</TableHead>
                                <TableHead>Unit Price</TableHead>
                                <TableHead>Total</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {request?.data?.line_items?.map((item: any) => (
                                <TableRow key={item.id}>
                                    <TableCell>
                                        <div className="flex items-center gap-4 py-3">
                                            <Avatar className="size-16 rounded-md">
                                                <AvatarImage src={item?.product?.image_url} alt="@shadcn" />
                                                <AvatarFallback>
                                                    <Footprints className="text-slate-500" />
                                                </AvatarFallback>
                                            </Avatar>
                                            <div className="text-gray-700">
                                                <h6 className="text-base font-bold">{item?.product_name ?? "Shoe Not Found"}</h6>
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell>{item.quantity}</TableCell>
                                    <TableCell>{item.price ? `$${item.price}` : "N/A"}</TableCell>
                                    <TableCell>{item.price ? `$${item?.quantity * item?.price}` : "N/A"}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Card>
                <Card className="mt-4 p-4 shadow-none">
                    <h3 className="text-lg font-bold">Reason</h3>
                    <Separator className="my-4" />
                    <p className="capitalize">{request?.data?.refund_reason || "N/A"}</p>
                </Card>
                <Card className="mt-4 p-4 shadow-none">
                    <h3 className="text-lg font-bold">Status</h3>
                    <Separator className="my-4" />
                    <p className="capitalize">{request?.data?.refund_status}</p>
                </Card>
            </div>
        </PageWrapper>
    );
};

export default RequestDetails;
